import { TextExpanderService, ToggledEvent } from '../../../_common/client/text-expander-service';
import { trackEvent } from '../../../_common/client/tracking';

export class CustomerReviewTextExpander {
    constructor(private textExpanderService: TextExpanderService) {}

    public registerTrackingEventOnExpanderToggled(rootElement: HTMLElement) {
        const reviewItemListIndex = this.extractReviewItemListIndex(rootElement);
        if (reviewItemListIndex === undefined) return;
        const selector = `.js_pdp_cr-item-expander-${reviewItemListIndex}`;
        this.textExpanderService.registerOnExpanderToggled(selector, (event: ToggledEvent) => {
            trackEvent({
                review_SingleReviewText: event.isOpen ? 'more' : 'less',
                review_SingleReviewPosition: reviewItemListIndex + 1,
            });
        });
    }

    public initTextExpanderButton(rootElement: HTMLElement) {
        const reviewItemListIndex = this.extractReviewItemListIndex(rootElement);
        if (reviewItemListIndex === undefined) return;
        const selector = `.js_pdp_cr-item-expander-${reviewItemListIndex}`;
        this.textExpanderService.sendInitEvent(selector);
    }

    private extractReviewItemListIndex(rootElement: HTMLElement): number | undefined {
        const { reviewItemListIndex } = rootElement.dataset;
        if (reviewItemListIndex === undefined) return;
        const parsedIndex = parseInt(reviewItemListIndex);
        return !isNaN(parsedIndex) ? parsedIndex : undefined;
    }
}
